export const notFoundPageContent = {
  title: '404 - Page Not Found',
  description: "The page you're looking for doesn't exist or has been moved.",
  btnGoBack: 'Go Back',
  btnGoHome: 'Go Home',
};
